import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./theme";
import i18n from "./i18n";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <I18nextProvider i18n={i18n}>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </I18nextProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
